// extracted by mini-css-extract-plugin
export default {"container":"supplierCard_container__0vtJ5","field":"supplierCard_field__96Dg-","imgUpload":"supplierCard_imgUpload__G8nDl","imgPreview":"supplierCard_imgPreview__Y1GLc"};